// Recuperer les info de l'instance pour certains champs
const userInfo = JSON.parse(localStorage.getItem("user"));

// Nom du user pour remplir representative
const userName = `${userInfo?.firstname} ${userInfo?.lastname}`

const emptyDataSDM = {
  id: null,
  UserId: null,
  productName: "SDM",
  productId: "2",
  phoneNumber: null,
  quoteCode: null,
  projectNumber: null,
  quoteDate: null,
  isActive: true,
  quotationStatus: "Active",
  estimativeShippingDate: new Date(),
  unitaryPriceCDN: null,
  unitaryPriceUSD: null,
  unitDesignation: null,
  numberUnits: 1,
  exchangeRate: null,
  shipping: "Not Included",
  representative: userName,
  ///////////// CHAMPS PROPRE À SDM /////////////
  airFlowType: "Constant",
  CFMHighVolume: null, 
  CFMMinVolume: null, 
  installation: "Outdoor", 
  temperatureRise: "90",
  externalStaticPressure: "1",
  gasType: "Natural",
  gasTrainType: "Standard", 
  dischargeLocation: "Horizontal", 
  motorSecurityFactor: "1.1", 
  voltage: "575/3/60", 
  controls: "Remote ctrl panel - Maxitrol 14 (55-90°F)",  
  interlock: "Simple interlock (STD)", 
  adjustablePrePurge: "Not Included", 
  dirtyFilterContact: "Not Included", 
  disconnectSwitch: "Included", 
  roomOverrideStat: "Not Included", 
  fanManufacturer: "Delhi",
  fanType: "Forward curved - STD",
  gasPressure: "14'' - 1/2 PSI",
  isolators: "Springs",
  beltGuard: "Not Included",
  accessSide: "Both side",
  elevation: 0,
  controlSide: "Right",
  flameControls: "FIREYE - FLAME ROD",
  damper: "Uninsulated",
  filterLocation: "In hood",
  filterInHood: "MERV 8",
  filterInCabinet: "MERV 8",
  extraFilters: "0",
  adjustableInletStat: "Fixe",
  ////////////////////////////////////////////////
  shipping: "Not Included",
  country: null,
  province: null,
  city: null,
  startUp: "Not Included",
  unitModel: null,
  mechanicalCode: null,
  margin: 0,
  leadTime: null,
  curbDrawing: null,
  electricalDiagram: null,
  unitaryPrice: null,
  unitaryShippingPrice: null,
  unitaryStartUpPrice: null,
  totalUnitaryPrice: null,
  isPriceValid: false,
  userCreation: null,
  dateCreation: new Date(),
  userModification: null,
  projectNumber: null,
  dateModification: new Date(),
  };

export default emptyDataSDM;

  
  